import DividerWithText from '../../../../../components/DividerWithText';
import { CustomTextField } from '../../../../../components/CustomTextField';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const Details = ({ t, item, disabled, emptyFields, handleChange, errorCode, errorName }) => {
    return (
        <>
            <div className={'col-12'}>
                <DividerWithText title={t('details')} spacing={'mb-4'} />
                <CustomTextField
                    id='txt_d_name'
                    name='name'
                    value={item?.name}
                    trans='name'
                    type='text'
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    isValid={errorName}
                    isValidText='the_value_already_exists'
                    required={true}
                    length={64}
                />
            </div>
            <div className='row'>
                <div className='col-sm-12 col-xxl-12 col-lg-12'>
                    <CustomTextField
                        id='txt_d_code'
                        name='code'
                        value={item?.code}
                        trans='code'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        isValid={errorCode}
                        isValidText='the_value_already_exists'
                        required={true}
                        length={16}
                    />
                </div>
            </div>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomTextField
                    id='txt_d_description'
                    name='description'
                    value={item?.description}
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    trans='description'
                    type='text'
                    multiline={true}
                    required={true}
                    length={512}
                />
            </div>
        </>
    );
};

export default Details;
